import { isDebugLogsEnabled, isLifecycleLogsEnabled } from '../config';
import { sanitizeLogArgs } from './sanitize.util';

export function emitLog(
  level: 'lifecycle' | 'debug' | 'warn' | 'error',
  message: string,
  args: unknown[] = []
): void {
  const sanitizedArgs = sanitizeLogArgs(args);

  if (level === 'lifecycle') {
    if (!isLifecycleLogsEnabled()) {
      return;
    }
    console.info(message, ...sanitizedArgs);
    return;
  }

  if (level === 'debug') {
    if (!isDebugLogsEnabled()) {
      return;
    }
    console.debug(message, ...sanitizedArgs);
    return;
  }

  if (level === 'warn') {
    console.warn(message, ...sanitizedArgs);
    return;
  }

  console.error(message, ...sanitizedArgs);
}
